import { render } from "./ActionPerspectives.vue?vue&type=template&id=ef93966e"
import script from "./ActionPerspectives.vue?vue&type=script&lang=js"
export * from "./ActionPerspectives.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__